<template>

    <FloatingPanel
        :title="title"
        :saveable="false"
    >

        <div class="canvas::editor-website-editors-loop-LoopPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">

                <div slot="Algemeen">

                    <SwitchInput
                        label="Aantal kolommen"
                        instruction="Kies hier het aantal kolommen per rij."
                        :items="[
                            { value: 2 },
                            { value: 3 },
                            { value: 4 },
                        ]"
                        :options="options"
                        :defaultValue="3"
                        options-property="columnsCount"
                        :open="true"
                    />

                    <accordion-input :open="true">
                        <template #label>

                            <div class="font-medium text-gray-600">Kleur</div>

                        </template>
                        <template #content>
                            <ColorsInput
                                label="Uitgelicht kleur"
                                instruction="Bepaal hier de kleur van de uitgelichte delen in de card."
                                :colors="colors"
                                :options="options"
                                options-property="highlightColor"
                                :accordion="false"
                                :spacing="{ 'horizontal': false, 'vertical': true }"
                            />
                        </template>
                    </accordion-input>

                    <SwitchInput
                        label="Toon knoppen"
                        instruction=""
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        :options="options"
                        options-property="showButtons"
                        defaultValue="1"
                    />
                    
                </div>

                <div slot="Design">

                    <ColorsInput
                        label="Achtergrondkleur van cards"
                        instruction="Bepaal hier de kleur van alle achtergronden van de onderliggende cards."
                        :colors="colors"
                        :options="options"
                        options-property="backgroundColor"
                        :open="true"
                    />

                    <accordion-input :open="false">
                        <template #label>

                            <div class="font-medium text-gray-600">Border / Rand</div>

                        </template>
                        <template #content>
                            <SwitchInput
                                label="Toon rand"
                                instruction=""
                                :options="options"
                                options-property="showBorder"
                                :items="[
                                    { value: 'uit', label: 'Uit'},
                                    { value: 'aan', label: 'Aan'},
                                ]"
                                defaultValue="uit"
                                :accordion="false"
                                :spacing="{'horizontal': false, 'vertical': true}"
                            />

                            <div class="mt-2 mb-3 font-medium text-gray-600">Rand stijl</div>
                            <select v-model="options.borderSize" class="px-4 py-2 mb-3 border border-gray-300 rounded-md">
                                <option value="1px" selected>1px</option>
                                <option value="2px">2px</option>
                                <option value="3px">3px</option>
                                <option value="4px">4px</option>
                            </select>

                            <select v-model="options.borderStyle" class="px-4 py-2 mb-3 border border-gray-300 rounded-md">
                                <option value="solid" selected>Solid</option>
                                <option value="dotted">Dotted</option>
                                <option value="dashed">Dashed</option>
                                <option value="double">Double</option>
                            </select>

                            <div class="mt-2 mb-3 font-medium text-gray-600">Rand afronding</div>
                            <select v-model="options.borderRounded" class="px-4 py-2 mb-3 border border-gray-300 rounded-md">
                                <option value="rounded-none" selected>Geen</option>
                                <option value="rounded-sm">Klein</option>
                                <option value="rounded">Normaal</option>
                                <option value="rounded-lg">Groot</option>
                                <option value="rounded-xl">XL</option>
                                <option value="rounded-2xl">XXL</option>
                                <option value="rounded-3xl">3XL</option>
                                <option value="rounded-full">Volledig rond</option>
                            </select>

                            <ColorsInput
                                label="Randkleur"
                                instruction="Bepaal hier de kleur van de rand van de button."
                                :colors="colors"
                                :options="options"
                                options-property="borderColor"
                                :accordion="false"
                                :spacing="{ 'horizontal': false, 'vertical': true }"
                            />

                        </template>
                    </accordion-input>

                </div>

            </Tabs>

            <div class="flex">

                <button class="btn btn-success justify-center flex-1 !rounded-none" @click="save">
                    <i class="mr-1 fa fa-save"></i> Opslaan
                </button>

                <button
                    class="btn btn-blue !rounded-none justify-center flex-1"
                    @click="addItem"
                >
                    <i class="mr-1 fa fa-plus"></i> Item toevoegen
                </button>

            </div>

        </div>

    </FloatingPanel>

</template>

<script>

import LoopPanel from "galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopPanel";
import FloatingPanel from "galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import SwitchInput from "galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {

    extends: LoopPanel,

    components: {
        FloatingPanel,
        SwitchInput,
        AccordionInput,
        Tabs,
        ColorsInput,
    },

    async mounted() {
        await this.loadColors();
    },

    data() {
        return {
            targets: {
                '_self': 'Huidige pagina',
                '_blank': 'Nieuwe pagina',
            },
            colors: null,
        };
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await getDatabaseColors(true)).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);

            let formattedColors = {};

            for (const color of this.colors) {
                if (typeof color === 'object') {
                    for (const [key, value] of Object.entries(color)) {
                        formattedColors[key] = value;
                    }
                } else {
                    formattedColors[color] = color;
                }
            }

            this.colors = formattedColors;
        },

    },

}

</script>

<style lang="scss" scoped>


</style>
